import { useEffect,useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import CloseIcon from "@mui/icons-material/Close"
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  DialogTitle,
  IconButton,
  Alert,
  Grid,
} from "@mui/material"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import Scans from "@/modules/Records/Scans/Scans2"
import { PhotosAndXRays } from "@/UDTreat/left/PhotosAndXRaysForCreatingProcess"
import { checkIsThereASpecifiedPhoto } from "@/UDTreat/left/utils"
import OrderForms from "@/UDTreat/USmartForms/OrderForms"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { closeAlert, setAlert } from "@/core/app/slices/alert/alertSlice"
import { RootState } from "@/core/app/store"
import { UAlert, UButton, UText } from "@/components/index"
import RefinePhotoList from "@/modules/Records/RefinePhotoList/RefinePhotoList"
import { setUploadStls } from "@/core/app/slices/records/scans/scansSlice"
import { setPhotoTypeJson } from "@/core/app/slices/records/photograph/photographSlice"
import CloseIconImg from "@/assets/svgs/close.svg"
import { setIsCreateNewRefinement, setWidthAll } from "@/UDTreat/udTreatSlice"
import { resetRxRefinementFormAdd } from "@/core/app/slices/uassist/formSlice"
import OrderFormsRefinement from "@/UDTreat/USmartForms/OrderFormsRefinement"
import { updateCaseById, updateCaseStatus } from "@/core/app/slices/case/caseThunkApi"
import { useParams } from "react-router-dom"

import {caseManagement, resourcesSynchronization, stageControl, wasmModule} from "@/gluelayer"
import { safeCloseWindow } from "@/core/app/CloseTabContext"
import { Form, FormContentRef } from "@/components/Form"
import { FormRenderMode, FormType } from "@/components/Form/types"
import FORM_CONSTANT from "@/core/app/slices/uassist/form.constant"
import { getFormByName } from "@/core/app/slices/uassist/form.util"
import NavigationBlockPopup from "@/components/NavigationBlockPopup/NavigationBlockPopup"
import isEqual from "lodash/isEqual"
import RxForm from "./RxForm"
import { CASE_STATUS } from "@/modules/Patient/config/status.config"
import useSTLupload from "@/modules/Records/Scans/useSTLupload"
import { setLoading } from "@/core/app/slices/clinical/clinicalSlice"

function getFileExtension(file: File) {
  // 使用split()方法将文件名拆分成名称和后缀
  const parts = file.name.split(".")
  const extension = parts[parts.length - 1].toLowerCase()
  return extension
}

export const CreateRefinement = ({ onClose }) => {
  const { refinementNum, widthAll } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const dispatch = useAppDispatch()
  const { t } = useTranslation("common")
  const { caseId, patientId } = useParams()
  const [step, setStep] = useState(0)
  const { uploadSTL } = useAppSelector((state) => state.scansService)
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { photoTypeJson } = useAppSelector((state) => state.PhotosService)
  const { alertMsg, isError, btnText, btnAction, timeout } = useAppSelector(
    (state: RootState) => state.alert,
  )
  const [isDataUpdated, setIsDataUpdated] = useState(false)
  const [showPrompt, setShowPrompt] = useState(false)
  const [initialFormData, setInitialFormData] = useState(null)

  const { uassist_progress="" } = useAppSelector((state: RootState) => state.caseService?.caseList[0])
  const { caseDisposition } = useAppSelector((state: RootState) => state.caseService?.caseDetail)

  const formRef = useRef<FormContentRef>(null)
  const [formRenderMode, setFormRenderMode] = useState<FormRenderMode>(FormRenderMode.EDIT)
  const [saveAndContinueLater, setSaveAndContinueLater] = useState(false)

  const upperModelCache = useRef(null)
  const lowerModelCache = useRef(null)
  
  const { formTemplateList } = useAppSelector(state => state.formService)
  const [currentFormType, setCurrentFormType] = useState(null)
  const { handleStlUpload } = useSTLupload()
  const scans2Ref = useRef<any>(null)

  const changeToNextStep = async () => {
    dispatch(closeAlert())
    if (step === 0) {
      dispatch(setLoading("pending"))
      const udesignCategory = caseDetail?.udesign_category
      if (!udesignCategory) {
        console.error("No udesignCategory in caseinfo...",caseDetail)
        dispatch(setLoading("complete"))
        return
      }
      const arches = udesignCategory.split("/")
      const isupper = arches[0].includes("R") || arches[0].includes("A");
      const islower = arches[1].includes("R") || arches[1].includes("A");
      if (isupper && islower && !uploadSTL.upper && !uploadSTL.lower) {
        dispatch(
          setAlert({
            message: t("records.scans.noScanFile"),
            isError: true,
          }),
        )
        dispatch(setLoading("complete"))
        setSaveAndContinueLater(false)
        return
      }else if (isupper && !uploadSTL.upper){
        dispatch(
          setAlert({
            message: t("records.scans.missUpperScan"),
            isError: true,
          }),
        )
        dispatch(setLoading("complete"))
        setSaveAndContinueLater(false)
        return
      }else if (islower && !uploadSTL.lower){
        dispatch(
          setAlert({
            message: t("records.scans.missLowerScan"),
            isError: true,
          }),
        )
        dispatch(setLoading("complete"))
        setSaveAndContinueLater(false)
        return
      }


            // check if need to save
      setTimeout(async () => {
        if (upperModelCache.current !== uploadSTL.upper) {
          upperModelCache.current = uploadSTL.upper
            ? uploadSTL.upper
            : null
          resourcesSynchronization.deleteFile(
            "test/case/Setting Data10/refinement/arch_u.mtc",
          )

          // save to virtual memory
          const stlFile = upperModelCache.current
          const ext = getFileExtension(stlFile) 
          let isSaveOk = false;
          if (ext === "stl") {
            const stlFilePath: Record<string, any> = {}
            stlFilePath["test/pre/arch_u.stl"] = stlFile
            await resourcesSynchronization.moduleFS(stlFilePath)
            const isSaveU = wasmModule.module.SaveMtcFileToFolder(
              "test/pre/arch_u.stl",
              "Setting Data10/refinement/arch_u.mtc",
            )
            isSaveOk= isSaveU
          }else if (ext === 'mtc') {
            await resourcesSynchronization.saveFileToZip(stlFile,'refinement/arch_u.mtc','Setting Data10')
            isSaveOk = true
          }
          console.log("isSaveUpperMTC :",isSaveOk)
        }

        if (lowerModelCache.current !== uploadSTL.lower) {
          lowerModelCache.current = uploadSTL.lower
            ? uploadSTL.lower
            : null
          resourcesSynchronization.deleteFile(
            "test/case/Setting Data10/refinement/arch_l.mtc",
          )

          // save to virtual memory
          const stlFile = lowerModelCache.current
          const ext = getFileExtension(stlFile) 
          let isSaveOk = false;
          if (ext === "stl") {
            let stlFilePath: Record<string, any> = {}
            stlFilePath["test/pre/arch_l.stl"] = stlFile
            await resourcesSynchronization.moduleFS(stlFilePath)

            const isSaveU = wasmModule.module.SaveMtcFileToFolder(
              "test/pre/arch_l.stl",
              "Setting Data10/refinement/arch_l.mtc",
            )
            isSaveOk = isSaveU
          }else if (ext === 'mtc') {
            await resourcesSynchronization.saveFileToZip(stlFile,'refinement/arch_l.mtc','Setting Data10')
            isSaveOk = true
          }
          
          console.log("isSaveLowerMTC :",isSaveOk)
        }

        //save current_course_check_number to arch_data.json
        const  uassist_round = caseDetail?.uassist_round ?? 0
        console.log("🚀 ~ changeToNextStep ~ uassist_round:",  uassist_round)
        await caseManagement.saveJsonDataToZip(
          JSON.stringify({ course_check_number:  uassist_round + 1 }),
          "refinement/arch_data.json",
          "Setting Data10",
        )

        scans2Ref.current?.saveRefinementSTLtoBulk10Zip()
        
        await handleStlUpload({
          patientId,
          caseId,
          uassist_round: caseDetail?.uassist_round,
          newUdesignJson: caseDetail?.udesign_json ? JSON.parse(caseDetail.udesign_json) : {},
        })
        saveAndContinueLater ? onClose() : setStep(step + 1)
        dispatch(setLoading("complete"))

      }, 100)

    } else if (step === 1) {
      // don't need check in refinement.
      // const ret = checkIsThereASpecifiedPhoto(photoTypeJson as any)
      // if (!ret.normalPosition || !ret.xrayPosition) {
      //   setShowAlert({
      //     isShow: true,
      //     message: t("records.dragAndDropDescriptions"),
      //   })
      //   return
      // }
      ![
        CASE_STATUS.FILL_OUT_RX_FORM,
        CASE_STATUS.SUBMIT_TO_UASSIST,
        CASE_STATUS.SUBMITTED_TO_UASSIST,
      ].includes(caseDisposition) &&
        await dispatch(
          updateCaseStatus({
            patientId,
            caseId,
            payload: { case_disposition: CASE_STATUS.FILL_OUT_RX_FORM , is_refinement: true},
          }),
        )
      saveAndContinueLater ? onClose() : setStep(step + 1)
    } else if ( step === 2) {
      setStep(step + 1)
    }
  }

  useEffect(() => {
    if (step === 1 && caseDetail?.udesign_json) {
      const udesign_json = JSON.parse(caseDetail.udesign_json)

      const upper = udesign_json.UpperType
      const lower = udesign_json.LowerType

      const newUdesignJson = { ...udesign_json }

      // Update UpperType based on stl upload conditions
      if (uploadSTL?.upper) {
        if (["A", "R"].includes(lower) && !["A", "R"].includes(upper)) {
          newUdesignJson.UpperType = lower
        }
      } else {
        newUdesignJson.UpperType = "--"
      }

      // Update LowerType based on stl upload conditions
      if (uploadSTL?.lower) {
        if (["A", "R"].includes(upper) && !["A", "R"].includes(lower)) {
          newUdesignJson.LowerType = upper
        }
      } else {
        newUdesignJson.LowerType = "--"
      }

      // Dispatch only if changes are detected
      if (
        newUdesignJson.UpperType !== udesign_json.UpperType ||
        newUdesignJson.LowerType !== udesign_json.LowerType
      ) {
        dispatch(
          updateCaseById({
            patientId,
            caseId,
            payload: {
              case_extra_attrs: JSON.stringify(newUdesignJson),
            },
          }),
        )
      }
    }
  }, [step, caseDetail, uploadSTL])
  
  const getCurrentStepComponent = () => {
    if (step === 0) {
      return <Scans ref={scans2Ref} isRefinement={true}/>
    } else if (step === 1) {
      return (
        <PhotosAndXRays
          isZoomoutAbled={true}
          isDragAbled={true}
          isDeleteAbled={true}
          refinementIndex={refinementNum}
        />
      )
    } else if (step === 2) {
      const getUassistFormIdByName = (name: string) =>
        getFormByName(formTemplateList, "UASSIST", name).id
  
      let formName = null
      if (uassist_progress === "REFINEMENT_READY") {
        formName = FORM_CONSTANT.REFINEMENT
      } else if (
        stageControl.getMaxStageNodeIndex() > 0 &&
        uassist_progress === "READY"
      ) {
        formName = FORM_CONSTANT.REFINEMENT_2
      }
      
      return (
        <Grid container justifyContent={"center"} gap={"45px"} sx={{mt:"30px"}}>
          <Grid
            item
            display={"flex"}
            flexDirection={"column"}
            minWidth={"520px"}
            // ref={preview}
            height={"720px"}
            sx={{
              visibility: widthAll ? "visible" : "hidden",
              marginLeft: widthAll ? "0" : "-520px",
            }}
          >
            <RefinePhotoList setSelectedPreview={setSelectedPreview} />
          </Grid>

          <Grid item sx={{ width: 640 }}>
            <RxForm
              ref={formRef}
              patientId={patientId}
              caseId={caseId}
              formName={formName}
              uassistRound={caseDetail?.uassist_round + 1}
              isDataUpdated={isDataUpdated}
              initialFormData={initialFormData}
              setInitialFormData={setInitialFormData}
              setIsDataUpdated={setIsDataUpdated}
              formRenderMode={formRenderMode}
              setFormRenderMode={setFormRenderMode}
              setCurrentFormType={setCurrentFormType}
              saveAndContinueLater={saveAndContinueLater}
              setSaveAndContinueLater={setSaveAndContinueLater}
              formSaveCallBack = {() => {
                setSaveAndContinueLater(false)
                onClose()
                if (widthAll) {
                  dispatch(setWidthAll(false))
                }
              }}
            />
            {currentFormType === FormType.UASSIST &&
            <Box sx={{display: "flex", justifyContent:"space-between", width: "100%"}} pt={2}>
              <Button
                variant={"outlined"}
                onClick={() => {
                  setSaveAndContinueLater(false)
                  if (isDataUpdated && formRenderMode === FormRenderMode.EDIT) {
                    setShowPrompt(true)
                  } else if(formRenderMode === FormRenderMode.SUMMARY){
                    setFormRenderMode(FormRenderMode.EDIT)
                  } else {
                    setStep(step - 1 > -1 ? step - 1 : 0)
                    setFormRenderMode(FormRenderMode.EDIT)
                  }
                }}
                sx={{ width: "92px", height: "36px" }}
              >
                <ChevronLeftIcon
                  fontSize={"small"}
                  sx={{ marginLeft: "3px" }}
                />
                {t("button.back")}
              </Button>

                {formRenderMode === FormRenderMode.EDIT && (
                  <>
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <Button
                        onClick={() => {
                          try {
                            setSaveAndContinueLater(true)
                            formRef.current?.setShowValidationErrors(true)
                            if (formRef.current.showValidationErrors) {
                              formRef?.current?.validateErrors()
                            }
                            console.log("Form data updated successfully")
                          } catch (error) {
                            console.error("Error updating form data:", error)
                          }
                        }}
                        variant="outlined"
                        sx={{
                          width: "auto",
                          height: "36px",
                          display: "inline-flex",
                        }}
                      >
                        {t("button.saveAndContinueLater")}
                      </Button>
                      <Button
                        variant={"contained"}
                        sx={{ width: "146px", height: "36px" }}
                        onClick={() => {
                          try {
                            formRef.current?.setShowValidationErrors(true)
                            if (formRef.current.showValidationErrors) {
                              formRef?.current?.validateErrors()
                            }
                            console.log("Form data updated successfully")
                          } catch (error) {
                            console.error("Error updating form data:", error)
                          }
                        }}
                      >
                        {"Review"}
                        <ChevronRightIcon
                          fontSize={"small"}
                          sx={{
                            height: "20px",
                            width: "20px",
                            marginLeft: "8px",
                          }}
                        />
                      </Button>
                    </Box>
                  </>
                )}

              { formRenderMode === FormRenderMode.SUMMARY && (<Button
                variant={"contained"}
                sx={{ height: "36px" }}
                onClick={() => {
                  (async ()=>{
                    await formRef.current?.submitToUassist()
                  })()
                }}
              >
                {t("button.submittoUassist")}
                <ChevronRightIcon
                  fontSize={"small"}
                  sx={{
                    height: "20px",
                    width: "20px",
                    marginLeft: "8px",
                  }}
                />
              </Button>)}
            </Box>}
          </Grid>
        </Grid>
      )
    }
  }

  useEffect(() => {

    dispatch(setPhotoTypeJson(null))
    return () => {
      // clear refinementAdd data
      dispatch(resetRxRefinementFormAdd())
      dispatch(
        setUploadStls({
          upper: null,
          lower: null,
      }),
    )
    }
  }, [])
  useEffect(() => {
    if(saveAndContinueLater && (step===0 || step===1)){
      changeToNextStep()
    }
  }, [saveAndContinueLater])

  // img zoom
  const [selectedPreview, setSelectedPreview] = useState("")
  // useEffect(() => {
  //   if (step !== 2 && widthAll) {
  //     dispatch(setWidthAll(false))
  //   }
  // }, [step])

  // Handler for confirming navigation in popup
  const handleConfirmNavigation = () => {
    setShowPrompt(false)
    setIsDataUpdated(false)
    setStep(step - 1 > -1 ? step - 1 : 0)
    setFormRenderMode(FormRenderMode.EDIT)
  }

  // Handler for cancelling navigation in popup
  const handleCancelNavigation = () => {
    setShowPrompt(false)
  }

  return (
    <Box
      id="createnewrefinement"
      sx={{
        backgroundColor: "white",
        width: widthAll ? "100%" : "60%",
        height: "100%",
        position: "absolute",
        top: "0",
        right: "0",
        zIndex: "10",
        overflowY: "auto",
        paddingTop: "40px",
        paddingBottom: "40px",
      }}
    >
      {/* <DialogTitle id="alert-dialog-title">
        {"Creating A Refinement"}
      </DialogTitle> */}
      <Button
        variant="contained"
        sx={{
          position: "absolute",
          left: 20,
          top: 20,
          display: step === 2 || widthAll ? "" : "none",
        }}
        onClick={async () => {
          await dispatch(setWidthAll(!widthAll))
          window.dispatchEvent(new Event("resize"))
        }}
      >
        {widthAll ? `Show Initial` : `View New Scans and PHotos`}
      </Button>
      <IconButton
        aria-label="close"
        onClick={() => {
          onClose()
          if (widthAll) {
            dispatch(setWidthAll(false))
          }
        }}
        sx={{
          position: "absolute",
          right: 12,
          top: 10,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Box
        id="context-container"
        sx={{
          display: "flex",
          justifyContent: "center",
          minHeight: "400px",
        }}
      >
        {getCurrentStepComponent()}
      </Box>
      <Box sx={{position: "absolute", bottom: 0, width: "100%", padding: "40px", flexDirection:'column', gap:2, display: (step==2 || step==3) ? "none" : "flex"}}>
        {step===0 && (uassist_progress==="REFINEMENT_READY") && (
          <Box sx={{background: "#e6e6e6", padding: 2, borderRadius: "4px", display:'flex', gap: 1}}>
            <InfoOutlinedIcon fontSize="small"/>
            <Box display="flex" flexDirection="column" >
              <UText variant="body1" sxProp={{fontWeight: 500}}>
                {t("treat.refinement.footer.title")}
              </UText>
              <UText variant="body2">
                {t("treat.refinement.footer.description")}
              </UText>
            </Box>
          </Box>
        )}
        <Box
          id="navigator"
          sx={{
            bottom: 0,
            width: "100%",
            display: "flex",
            justifyContent: (uassist_progress!=="REFINEMENT_READY" && step === 0) ? "flex-end" : "space-between",
          }}
        >
          {step === 0 && (uassist_progress==="REFINEMENT_READY") && (
            <Button
              variant={"contained"}
              onClick={() => {
                safeCloseWindow()
              }}
              sx={{ height: "36px", backgroundColor: "#e6e6e6", color: theme => theme.palette.text.primary, "&:hover": { backgroundColor: "#e0e0e0" } }}
            >
              {t("button.cancelRefinement")}
            </Button>
          )}
          {step !== 0 && step !== 2 && (
              <Button
                variant={"outlined"}
                onClick={() => {
                  setSaveAndContinueLater(false)
                  setStep(step - 1 > -1 ? step - 1 : 0)
                }}
                sx={{ width: "92px", height: "36px" }}
              >
                <ChevronLeftIcon fontSize={"small"} sx={{ marginLeft: "3px" }} />
                {t("button.back")}
              </Button>
          )}
          
          <Box sx={{ display: "flex", gap: 2 }}>
            {step !== 2 && (
                <Button
                  onClick={ async () => {
                    setSaveAndContinueLater(true)
                    if (widthAll) {
                      dispatch(setWidthAll(false))
                    }
                  }}
                  variant="outlined"
                  sx={{
                    width: "auto",
                    height: "36px",
                    display: "inline-flex",
                  }}
                >
                  {t("button.saveAndContinueLater")}
                </Button>
            )}
            {step !== 2 && (
                <Button
                  onClick={() => {
                    changeToNextStep()
                  }}
                  variant="contained"
                  sx={{
                    right: "10px",
                    width: "92px",
                    height: "36px",
                  }}
                >
                  {t("button.next")}
                  <ChevronRightIcon sx={{ marginLeft: "3px" }} fontSize={"small"} />
                </Button>
            )}
          </Box>
        </Box>
      </Box>
      <NavigationBlockPopup
        cancelNavigation={handleCancelNavigation}
        confirmNavigation={handleConfirmNavigation}
        showPrompt={showPrompt && isDataUpdated}
      />
      <UAlert
        horizontalPosition={"right"}
        timeout={timeout}
        alertContent={
          <>
            <UText
              sxProp={{
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "143%",
              }}
            >
              {alertMsg}
            </UText>
            {!!btnText && !!btnAction && (
              <UButton
                sxProp={{
                  width: "120px",
                  height: "30px",
                  color: "#ffffff",
                  border: "1px solid #ffffff",
                  borderRadius: "4px",
                  fontSize: "13px",
                  marginLeft: 2,
                  padding: "4px 10px",
                }}
                onClickHandler={btnAction}
                btnText={btnText}
              />
            )}
          </>
        }
        variant={"filled"}
        severity={isError ? "error" : "success"}
        alertProps={{ paddingBottom: "10px" }}
        showAlert={alertMsg !== ""}
        onClickHandler={(action) => {
          if (action === 'clickaway') {
            return;
          }
          dispatch(closeAlert());
        }}
      ></UAlert>
      {selectedPreview && (
        <>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            <Box
              display="flex"
              justifyContent="center"
              position="fixed"
              top="120px"
              bottom="120px"
              left="120px"
              right="120px"
              overflow="hidden"
            >
              <Box
                id="backdrop"
                position="relative"
                width="inherit"
                height="inherit"
              >
                <img
                  src={selectedPreview}
                  alt={"fullscreenimg"}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  loading="lazy"
                />
                <Box
                  component={"div"}
                  id="closeicon"
                  position="absolute"
                  top="0px"
                  right="0px"
                  sx={{ padding: "8px" }}
                >
                  <IconButton
                    size="medium"
                    sx={{
                      fontSize: "large",
                      backgroundColor: "divider",
                      padding: "0px",
                      ":hover": { backgroundColor: "divider" },
                    }}
                    onClick={() => setSelectedPreview("")}
                  >
                    <Box
                      component={"img"}
                      src={CloseIconImg}
                      alt={"Logo"}
                      loading="lazy"
                      sx={{ cursor: "pointer", padding: "12px" }}
                    />
                  </IconButton>
                </Box>
              </Box>
            </Box>
          </Backdrop>
        </>
      )}
      
    </Box>
  )
}
